import DescriptionDetails from "components/DescriptionDetails";
import FormFieldViewText from "components/FormFields/ViewText";
import SpacePath from "components/SpacePath";
import TagsList from "components/TagsList";
import FormField from "ds/components/Form/Field";
import { showFullDescription } from "ds/components/FullDescriptionDrawer";
import useTypedContext from "hooks/useTypedContext";
import tooltips from "shared/Scan/tooltips";

import { ScanSettingsContextData } from "../Context";

const ScanSettingsDetailsView = () => {
  const { scanSettings } = useTypedContext(ScanSettingsContextData);

  const onOpenFullDescription = () => {
    showFullDescription({ description: scanSettings.description });
  };

  return (
    <>
      <FormFieldViewText
        label="Name"
        value={scanSettings.name}
        noMargin
        tooltipInfo={tooltips.NAME}
        tooltipInfoVariant="modal"
      />

      <FormField label="Space" noMargin tooltipInfo={tooltips.SPACE} tooltipInfoVariant="modal">
        <SpacePath
          variant="expandable"
          spaceId={scanSettings.space.id}
          fallbackName={scanSettings.space.name}
        />
      </FormField>

      <FormField label="Labels" noMargin tooltipInfo={tooltips.LABELS} tooltipInfoVariant="modal">
        <TagsList tags={scanSettings.labels} alwaysExpanded withEmptyPlaceholder />
      </FormField>

      <DescriptionDetails
        description={scanSettings.description}
        onOpenFullDescription={onOpenFullDescription}
        noMargin
      />
    </>
  );
};

export default ScanSettingsDetailsView;
